import { useState } from 'react';
import FormLogin from 'components/forms/FormLogin';
import FormSignup from 'components/forms/FormSignup';
import classNames from 'styles/utils/classNames';
import StepHeader from './StepHeader';

interface Props {
  onBack: () => void;
  /** Resumes the booking once the viewer is signed in. */
  onAuthComplete: () => void;
  className?: string;
}

const FORM_CLASSES = {
  formWrapperClassName: 'px-ds-xl pb-ds-lg',
  buttonWrapperClassName: 'px-ds-xl pb-ds-xl',
  spacerClassName: 'space-y-ds-xl',
};

/**
 * The court is held in the player's name, so an anonymous visitor signs in
 * between picking a time and paying.
 *
 * This is the same in-flow step the tournament and lesson flows use — the shared
 * forms in `isFormOnly` mode under the booking step's own header. `shouldSkipReload`
 * is what makes it a step rather than a detour: signup would otherwise reload the
 * page and throw away the slot selection the flow is holding.
 */
export default function BookingAuthStep({ onBack, onAuthComplete, className }: Props) {
  const [isLogin, setIsLogin] = useState(false);

  return (
    <div className={classNames('flex flex-col', className)}>
      <StepHeader
        title={isLogin ? 'Log in to book' : 'Create an account to book'}
        onBack={onBack}
      />

      <div className="overflow-y-auto">
        {isLogin ? (
          <FormLogin
            isFormOnly
            isShowSignupLink
            shouldSkipReload
            toggleSignup={() => setIsLogin(false)}
            handleAuthComplete={onAuthComplete}
            {...FORM_CLASSES}
          />
        ) : (
          <FormSignup
            isFormOnly
            isShowLoginLink
            shouldSkipReload
            toggleLogin={() => setIsLogin(true)}
            handleAuthComplete={onAuthComplete}
            {...FORM_CLASSES}
          />
        )}
      </div>
    </div>
  );
}
